var t;!function(t){t.Practitioner="practitioner",t.Patient="patient"}(t||(t={}));export{t as UserType};
